import { Component, Host, h, Prop, Event, Listen, EventEmitter, Element } from '@stencil/core';
import IconBubbleFilled from '../../../assets/images/svg/Bubble_Filled.svg';
import IconBubble from '../../../assets/images/svg/Bubble.svg';
import Supercard_01 from '../../../assets/images/svg/Supercard_01.svg';
import Checkbox_01 from '../../../assets/images/svg/Checkbox_01.svg';
import PickUp from '../../../assets/images/svg/pickup--white.svg';
import { createCSSVariablesForFontsizes } from '../../../utils/utils';
@Component({
  tag: 'lilu-icon',
  styleUrl: 'lilu-icon.scss',
  shadow: true,
})
export class LiluIcon {
  @Prop() type = '';
  @Prop() color = 'nero';
  @Prop() size = '';
  @Prop() border = '';
  @Prop() backgroundcolor = '';
  @Prop() appearance = '';
  @Prop() halfColor: string = null;
  @Prop() isListBullet = false;

  @Element() element: HTMLElement;

  styles = {};

  @Event() clickLiluIcon: EventEmitter<object>;

  clickLiluIconHandler(evt: object) {
    this.clickLiluIcon.emit(evt);
  }

  @Listen('click')
  handleEvent(e) {
    this.clickLiluIconHandler(e);
  }

  componentWillLoad() {
    this.styles = {};

    if (this.backgroundcolor) {
      this.styles['background-color'] = `var(--${this.backgroundcolor})`;
    }

    if (this.isListBullet) {
      this.styles = {
        ...this.styles,
        transform: 'translateY(-1px)',
        margin: '0 10px 0 0',
      };
    }

    createCSSVariablesForFontsizes(this.element, this.size);
  }

  render() {
    return (
      <Host class={`${this.size} ${this.appearance}`} part={`${this.size}`}>
        {this.type === 'icon-bubble-filled' ||
        this.type === 'icon-bubble' ||
        this.type === 'icon-supercard-01' ||
        this.type === 'icon-checkbox-01' ||
        this.type === 'icon-pickup' ? (
          <span part="span" style={this.styles} class={`svg-container ${this.size} ${this.type} ${this.border} ${this.color}`}>
            <img src={this.getBase64SVG()} alt={this.type} />
          </span>
        ) : (
          <span part="span" style={this.styles} class={`icon ${this.type} ${this.border} size ${this.color}`}>
            {this.halfColor && <span part="span" style={this.styles} class={`halfColor icon ${this.type} ${this.border} size ${this.halfColor}`}></span>}
            <slot name="popover"></slot>
          </span>
        )}
      </Host>
    );
  }

  getBase64SVG(): any {
    switch (this.type) {
      case 'icon-bubble-filled':
        return IconBubbleFilled;

      case 'icon-bubble':
        return IconBubble;

      case 'icon-supercard-01':
        return Supercard_01;

      case 'icon-checkbox-01':
        return Checkbox_01;

      case 'icon-pickup':
        return PickUp;
    }
    return null;
  }
}
